export const EXTENSION_NAME = "fashion-promenade-terminal"
// Used with `theme.breakpoints.up(...)` to hide mobile-only UI on desktop.
// Set to 1024 so iPad Pro portrait (1024) and up receive the desktop layout
// (parking finder + desktop buttons), matching MUI's standard `lg` breakpoint.
export const TABLET_MAX_BREAKPOINT = 1024
